import React from 'react';

const Contact = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">Contact Us</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-bold text-royal-blue mb-4">Get in Touch</h2>
          <p className="text-gray-700 mb-2">
            <strong>Address:</strong> NSSF Building, Nkurumah Road, Mombasa, Kenya
          </p>
          <p className="text-gray-700 mb-2">
            <strong>P.O. Box:</strong> 93781-80102, Mombasa
          </p>
          <p className="text-gray-700 mb-2">
            <strong>Phone:</strong> +254 727 103 526 | 0732 333 955 | 0727 365 416
          </p>
          <p className="text-gray-700 mb-2">
            <strong>Email:</strong> ekulconsultingagency@gmail.com
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-royal-blue mb-4">Location</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.747501655678!2d39.67944337428077!3d-4.045239053559655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x184012e3a9b4e3c3%3A0x5a6c5f5f5f5f5f5f!2sNSSF%20Building%2C%20Nkurumah%20Road%2C%20Mombasa!5e0!3m2!1sen!2ske!4v1696522458000"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Ekul Consulting Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;